(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-search-bar"] && !Shopify.designMode) return;
  try {
    class AiSearchBar extends HTMLElement {
    #index = 0;
    #timer = 0;
    #terms = [];

    connectedCallback() {
      this.input = this.querySelector('.ai-search__input');
      this.term = this.querySelector('.ai-search__term');

      try {
        const raw = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '[]');
        this.#terms = raw.map((t) => String(t).trim()).filter(Boolean);
      } catch {
        this.#terms = [];
      }

      // Product names come in catalog order; shuffle so each visit shows a different mix
      if (this.hasAttribute('data-shuffle') && this.#terms.length > 1) {
        for (let i = this.#terms.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.#terms[i], this.#terms[j]] = [this.#terms[j], this.#terms[i]];
        }
        if (this.term) this.term.textContent = this.#terms[0];
      }

      this.input?.addEventListener('input', this.#syncValue);
      document.addEventListener('keydown', this.#onKeydown);
      this.#syncValue();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.#terms.length > 1 && !reduced) {
        this.#timer = window.setInterval(this.#next, 2800);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.#timer);
      document.removeEventListener('keydown', this.#onKeydown);
    }

    #syncValue = () => {
      this.toggleAttribute('has-value', Boolean(this.input?.value));
    };

    #next = () => {
      if (!this.term || this.hasAttribute('has-value') || document.hidden) return;

      this.#index = (this.#index + 1) % this.#terms.length;
      const term = this.term;
      term.classList.add('is-leaving');

      window.setTimeout(() => {
        term.textContent = this.#terms[this.#index];
        term.classList.remove('is-leaving');
        term.classList.add('is-entering');
        void term.offsetWidth;
        term.classList.remove('is-entering');
      }, 380);
    };

    /** Press "/" anywhere on the page to jump into the search bar */
    #onKeydown = (event) => {
      if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return;
      const target = event.target;
      if (target instanceof HTMLElement && (target.isContentEditable || target.closest('input, textarea, select'))) return;

      event.preventDefault();
      this.input?.focus();
    };
  }

  if (!customElements.get('ai-search-bar')) {
    customElements.define('ai-search-bar', AiSearchBar);
  }
  } catch(e) { console.error(e); }
})();

})();
